import { render, staticRenderFns } from "./OnboardingActions.vue?vue&type=template&id=5e58a324&"
import script from "./OnboardingActions.vue?vue&type=script&lang=js&"
export * from "./OnboardingActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports